import { useAnimations } from "@react-three/drei";
import { useDracoGLTF } from "../../../utils/useDracoGLTF";
import { useTranslation } from "react-i18next";
import { useMemo, useEffect } from "react";
import { findObjectStartsWithKey } from "../../../utils/FindObjects";
import Hotspot from "../../ui/Hotspot";

import HardeningTemperingProcess from "./HardeningTemperingProcess";

import { Vector3 } from "three";

import fragmentShaderReplacement from "../shader/VertexColorHeat_Distance_replacement_frag.glsl";
import fragmentShaderAddition from "../shader/VertexColorHeat_Distance_addition_frag.glsl";

import vertexShaderReplacement from "../shader/VertexColorHeat_Distance_replacement_vert.glsl";
import vertexShaderAddition from "../shader/VertexColorHeat_Distance_addition_vert.glsl";
import { Ebbne, MountWithEbbne, useEbbne } from "@solidwhite/ebbnen";
import SetCameraTarget from "../SetCameraTarget";

const HardeningTempering = ({ ...props }) => {
  const { nodes, scene, animations } = useDracoGLTF("./models/heat/Hardening_Tempering.glb");

  const { actions } = useAnimations(animations, scene);

  const hotSpots = useMemo(() => {
    var hotspots = [];
    var hsParent;
    hsParent = findObjectStartsWithKey("Labels_Root", scene);
    if (hsParent) {
      hsParent.children.forEach((c) => hotspots.push(c));
    }

    return hotspots;
  }, []);

  const cameraTargets = useMemo(() => {
    var obj = findObjectStartsWithKey("CameraTargets_All", scene);
    var camTargets = {};
    obj.children.forEach((c) => {
      if (c.userData.route) camTargets[c.userData.route] = c;
    });

    return camTargets;
  });

  const [workpiece, heatSource] = useMemo(() => {
    // var workpiece = findObjectStartsWithKey(
    //   "Weldac_Animation9_Weldac_Animation6_ME_Pipe",
    //   object3d
    // );
    var workpiece = nodes.ME_HardeningTempering_Workpiece001;

    // var heatSource = findObjectStartsWithKey("Heat_Source", object3d);
    var heatSource = nodes.Heat_Source;

    var heatSourceWorld = new Vector3();
    heatSource.getWorldPosition(heatSourceWorld);

    var materialClone = workpiece.material.clone();
    // var materialClone = new MeshStandardMaterial();

    // materialClone.uniforms = {
    //   uHeat: {
    //     value: 0.0,
    //   },
    //   uHeatFallof: {
    //     value: 0.9,
    //   },
    //   ...materialClone.uniforms,
    // };

    materialClone.onBeforeCompile = (s) => {
      s.uniforms.uHeat = {
        value: 0.0,
      };
      s.uniforms.uHeatFallof = {
        value: 0.9,
      };
      s.uniforms.uHardened = {
        value: 1.0,
      };
      s.uniforms.uHeatSource = {
        value: heatSourceWorld,
      };
      s.uniforms.uHeatDistance = {
        value: 0.85,
      };
      s.vertexShader = `${vertexShaderAddition}${s.vertexShader}`;
      s.vertexShader = s.vertexShader.replace(`#include <fog_vertex>`, vertexShaderReplacement);

      s.fragmentShader = `${fragmentShaderAddition}\n${s.fragmentShader}`;
      s.fragmentShader = s.fragmentShader.replace(`#include <color_fragment>`, ``);
      s.fragmentShader = s.fragmentShader.replace(`#include <dithering_fragment>`, fragmentShaderReplacement);

      materialClone.userData.shader = s;
    };

    workpiece.material = materialClone;

    return [workpiece, heatSource];
  }, []);

  return (
    <group>
      <primitive object={scene} />
      <group
        position={nodes.Hardening_Tempering_1.position}
        rotation={nodes.Hardening_Tempering_1.rotation}
        scale={nodes.Hardening_Tempering_1.scale}
      >
        <Ebbne id="htprocess">
          <HTHotspots hotSpots={hotSpots} />
          <MountWithEbbne mountedWhen="visible"></MountWithEbbne>
          <MountWithEbbne>
            <SetCameraTarget settingsObject={cameraTargets["/applications/hardeningTempering/process"]} />
            <HardeningTemperingProcess
              action={actions["ME_HardeningTempering_Coil.001|ME_HardeningTempering_Coil.001|ME_HardeningTempering_Coil.001|M"]}
              // measureData={measureData}
              workpiece={workpiece}
              heatSource={heatSource}
              scene={scene}
              root={nodes.Hardening_Tempering_1}
            />
          </MountWithEbbne>
        </Ebbne>
      </group>
    </group>
  );
};

const HTHotspots = ({ hotSpots }) => {
  const { select, selectable } = useEbbne();

  const { t } = useTranslation();

  const handleLabelClick = (e) => {
    e.stopPropagation();
    select();
  };

  console.log(hotSpots);

  return (
    <>
      {selectable &&
        hotSpots.map((hotspot, idx) => (
          <Hotspot
            position={hotspot.position}
            text={hotspot.userData.textId ? t(hotspot.userData.textId) : hotspot.name.toUpperCase()}
            topLeft
            onClick={(e) => handleLabelClick(e)}
            delay={20 + 300 * idx}
            id={hotspot.name}
            key={hotspot.name}
          />
        ))}
    </>
  );
};

useDracoGLTF.preload("./models/heat/Hardening_Tempering.glb");

export default HardeningTempering;
